<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-input ttLabel="word_id" [ttModel]="edit.word_id" ttReadonly></tt-input>
        <tt-input ttLabel="language_id" [ttModel]="edit.language_id" ttReadonly></tt-input>
        <tt-textarea ttLabel="wordlang_name" [(ttModel)]="edit.wordlang_name"></tt-textarea>
        <tt-input ttLabel="proc_call_syntax" [ttModel]="edit.proc_call_syntax" ttReadonly></tt-input>
        <tt-button-save ttText="msgcreate_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
